import React from 'react';
import { StreamingOverviewResponse } from 'fym-shared/src/music24/streaming';
import { TypedMemo } from '../../../../common/types';
import { PeriodSectionGateView } from '../../period/PeriodSectionGateView';
import { shortVideoMessages as messages } from '../../shortVideoMessages';
import { ShortVideoBody } from './ShortVideoBody';

interface ShortVideoSectionProps {
  accountId: number;
  overview: StreamingOverviewResponse;
  onOpenCatalog: () => void;
}

/** Streaming → Short video (design streaming-sections c1, c2, e2, e4): the videos made with the songs. */
const ShortVideoSectionComponent: React.FC<ShortVideoSectionProps> = ({ accountId, overview, onOpenCatalog }) => (
  <PeriodSectionGateView
    overview={overview}
    section="shortVideo"
    emptyTitle={messages.emptyTitle}
    emptyText={messages.emptyText}
    onOpenCatalog={onOpenCatalog}
  >
    <ShortVideoBody accountId={accountId} days={overview.days} />
  </PeriodSectionGateView>
);

export const ShortVideoSection = TypedMemo(ShortVideoSectionComponent);
